/** Packages **/
import React from 'react';
import PropTypes from 'prop-types';
import CardHead from '../../components/CardHead';
import { hasClass } from './../CalendarActivities/helpers.js';
// Styles
import './styles.scss';

const MainCardContainer = (props) => {
  const extraClass = props.isHeaderLayout ? 'pl-15' : '';
  const leftMenu = document.querySelector('.Drawer');
  let isHide = false;
  if (leftMenu) {
    isHide = hasClass(leftMenu, 'hidden');
  }

  const { readOnly } = props;

  return (
    <section style={isHide ? { paddingLeft: '15px' } : {}} className={`expanded row card-container ${extraClass}`}>
      <div className={readOnly ? 'large-12 columns' : 'large-12 columns main-card-head'}>
        <CardHead
          title={props.headTitle}
          subtitle={props.headSubtitle}
          hasMenu={props.hasMenu}
          headClassName={props.headClassName}
          rightElement={props.rightElement}
        />
      </div>
      {props.content}
    </section>
  );
};

MainCardContainer.propTypes = {
  headTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  headSubtitle: PropTypes.string,
  content: PropTypes.array.isRequired,
  hasMenu: PropTypes.bool,
  headClassName: PropTypes.string,
  isHeaderLayout: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  rightElement: PropTypes.any,
};

MainCardContainer.defaultProps = {
  headSubtitle: '',
  hasMenu: false,
  headClassName: '',
  isHeaderLayout: false,
  readOnly: false,
  rightElement: null,
};

export default MainCardContainer;
